// Etiquetas NEW y «Mejorado» de los widgets de la galería de la app.
// El modelo es el MISMO que usa la app: se importa su archivo tal cual (deja
// TCWidgetMarks en global), así las reglas y los límites no se copian aquí.
import '../../../renderer/tabs/widgets/marcas-modelo.js';
import { APP_IMPROVED_BADGES, APP_NEW_BADGES } from '../data/widgets-catalog';

export const WidgetMarks = globalThis.TCWidgetMarks;

export const MARK_FIELDS = {
  newSince: { label: 'NEW', title: 'Etiqueta NEW', since: 'Nuevo desde', days: 'newDays', app: APP_NEW_BADGES },
  improvedSince: { label: 'MEJORADO', title: 'Etiqueta «Mejorado»', since: 'Mejorado desde', days: 'improvedDays', app: APP_IMPROVED_BADGES }
};

export const today = () => new Date().toISOString().slice(0, 10);
export const spanishDay = (day) => (day ? day.split('-').reverse().join('/') : '');

/**
 * La clave con la que se guarda la etiqueta de una tarjeta del catálogo: la del
 * widget o, en una animación, la de su pack (las animaciones van por packs y
 * solo llevan NEW).
 */
export function markKeyFor(widget) {
  if (!widget) return '';
  return widget.animation ? (widget.pack ? `anim-pack-${widget.pack}` : '') : widget.key;
}

/** Los campos que tiene sentido poner en esa tarjeta. */
export function markFieldsFor(widget) {
  if (!widget || !markKeyFor(widget)) return [];
  return widget.animation ? ['newSince'] : ['newSince', 'improvedSince'];
}

/**
 * Cómo está una etiqueta de un widget:
 *   source  'backoffice' (dicho aquí) | 'app' (como viene en la app)
 *   since   el día puesto aquí (o null = «sin etiqueta», o undefined si manda la app)
 *   until   último día en que se ve ('' si no aplica)
 *   live    ¿se ve hoy en la app?
 */
export function markStatus(config, key, field, day = today()) {
  const meta = MARK_FIELDS[field];
  const clean = WidgetMarks.sanitize(config);
  const entry = clean.items[key];
  const appUntil = meta.app[key] || '';
  if (entry && Object.prototype.hasOwnProperty.call(entry, field)) {
    const since = entry[field];
    const until = since ? WidgetMarks.lastDay(since, clean.days[meta.days]) : '';
    return { source: 'backoffice', since, until, live: !!since && since <= day && day <= until, appUntil };
  }
  return { source: 'app', since: undefined, until: appUntil, live: !!appUntil && day <= appUntil, appUntil };
}

/** La frase que explica ese estado. */
export function markStatusText(status) {
  if (status.source === 'backoffice') {
    if (!status.since) return 'Sin etiqueta (puesto aquí)';
    if (today() < status.since) return `Empieza el ${spanishDay(status.since)} y se ve hasta el ${spanishDay(status.until)}`;
    return status.live ? `Se ve hasta el ${spanishDay(status.until)}` : `Caducó el ${spanishDay(status.until)}`;
  }
  if (!status.appUntil) return 'Como viene en la app: sin etiqueta';
  return status.live
    ? `Como viene en la app: se ve hasta el ${spanishDay(status.appUntil)}`
    : `Como viene en la app: caducó el ${spanishDay(status.appUntil)}`;
}

/** La etiqueta que lleva hoy la tarjeta de ese widget en la app: 'new' | 'improved' | '' (NEW manda). */
export function liveMark(config, widget, day = today()) {
  const key = markKeyFor(widget);
  if (!key) return '';
  if (markStatus(config, key, 'newSince', day).live) return 'new';
  if (!widget.animation && markStatus(config, key, 'improvedSince', day).live) return 'improved';
  return '';
}
